import { render, staticRenderFns } from "./appApprovals.vue?vue&type=template&id=b871917e&scoped=true"
import script from "./appApprovals.vue?vue&type=script&lang=js"
export * from "./appApprovals.vue?vue&type=script&lang=js"
import style0 from "./appApprovals.vue?vue&type=style&index=0&id=b871917e&prod&scoped=true&lang=scss"
import style1 from "./appApprovals.vue?vue&type=style&index=1&id=b871917e&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b871917e",
  null
  
)

export default component.exports